export const faqs = [
  {
    id: 'f-1',
    question: '「511群众」上的内容都是从哪来的？',
    answer:
      '内容来自吃瓜小队在公开场合的现场见闻，以及公开热榜话题的脉络梳理。我们只整理已经公开、可以被多人验证的信息，不做私人渠道的猜测，也不传播未经证实的说法。',
  },
  {
    id: 'f-2',
    question: '为什么有的瓜点看起来只有背景，没有结论？',
    answer:
      '很多话题在当下其实并没有定论。与其给出一个可能不准确的结论，我们更愿意把时间线、各方提到的细节摆出来，让你自己判断。等有新的公开进展，我们会在原页面补充更新。',
  },
  {
    id: 'f-3',
    question: '我可以把自己看到的现场情况提供给你们吗？',
    answer:
      '可以。如果你在公开活动中拍到了值得记录的瞬间，或者有清晰的现场观察，欢迎通过页面底部的联系方式发给我们。请尽量附上时间、地点，方便我们核对。',
  },
  {
    id: 'f-4',
    question: '蹲点记录和普通报道有什么区别？',
    answer:
      '蹲点记录更关注过程：几点到、排了多久、现场秩序如何、散场顺不顺畅。这些细节看起来不起眼，但对真正要去现场的人反而最有用。',
  },
  {
    id: 'f-5',
    question: '内容更新频率是怎样的？',
    answer:
      '没有固定频率，跟着话题走。热榜话题通常当天或次日更新脉络，现场类内容一般在活动结束后一天内整理完成。冷门但有意思的记录我们也会慢慢补上。',
  },
  {
    id: 'f-6',
    question: '你们会删除已经发布的内容吗？',
    answer:
      '会。如果某条记录后来被证实有误，或者当事人提出合理异议，我们会更正或下架。我们更在意内容靠不靠谱，而不是发出去就不改了。',
  },
];